import * as React from 'react';
import * as Compat from '../Compat';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import { Trad } from './';

export function CheckState(state: any, regole: any, listaCampiEsclusi: string[] = []): string[] {
    let errori: string[] = [];
    let array: any[] = JSON.parse(RegolaValidazione("", state, regole));
    for (let i: number = 0; i < array.length; i++) {
        if (listaCampiEsclusi.indexOf(array[i].Campo) > -1) {
            continue;
        }
        for (let x: number = 0; x < array[i].Regole.length; x++) {
            if (array[i].Regole[x].Soggetto != undefined && array[i].Regole[x].Soggetto.indexOf("[]") > 0) {
                errori = ControlloErroriTabella(state, array[i].Campo, array[i].Regole[x], errori);
            } else {
                errori = ControlloErrori(state, array[i].Campo, array[i].Regole[x], errori, array[i].Regole[x].Soggetto);
            }
        }
    }

    return errori;
}

export function RegolaValidazione(campo: string, state: any, regole: any): Glob.DatiJSON {
    if (regole != undefined) {
        let Regole: any[] = JSON.parse(regole);
        for (let i: number = Regole.length - 1; i >= 0; i--) {
            if (Regole[i].Campo == campo || campo == "") {
                for (let x: number = 0; x < Regole[i].Regole.length; x++) {
                    if ((Regole[i].Regole[x].Azione == "<" || Regole[i].Regole[x].Azione == ">" || Regole[i].Regole[x].Azione == "=" || Regole[i].Regole[x].Azione == "<=" || Regole[i].Regole[x].Azione == ">=") && Regole[i].Regole[x].Soggetto != undefined)
                        Regole[i].Regole[x].Valore = state[Regole[i].Regole[x].Soggetto];
                }
                if (campo == "") {
                    return JSON.stringify(Regole);
                }
            }
        }
        return JSON.stringify(Regole);
    }
    else {
        return "[]";
    }
}

export function ControlloErroriTabella(state: any, nomeCampo: any, regola: any, errori: string[]): string[] {
    let i: number = 0;
    let tagBaseValue = regola.Soggetto;
    do {
        regola.Soggetto = tagBaseValue.replace("[]", "[" + i + "]");
        if (regola.Soggetto.indexOf("[]") > 0) {
            ControlloErroriTabella(state, nomeCampo, regola, errori);
        } else {
            if (GetValueFromString(state, regola.Soggetto, regola.Valore) != undefined) {
                errori = ControlloErrori(state, nomeCampo, regola, errori, tagBaseValue);
            }
        }
        i++;
    } while (GetValueFromString(state, regola.Soggetto, undefined) != undefined);
    return errori;
}

export function ControlloErrori(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (regola.Azione == ">") {
        errori = Maggiore(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == ">=") {
        errori = MaggioreUguale(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "<") {
        errori = Minore(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "<=") {
        errori = MinoreUguale(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "=") {
        errori = Uguale(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "Alternative") {
        errori = Alternativo(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "Required") {
        errori = Richiesto(state, nomeCampo, regola, errori, etichetta);
    } else if (regola.Azione == "Amount") {
        errori = Somma(state, nomeCampo, regola, errori, etichetta);
    } else {
        errori = AddErrore(errori, Trad.TradParam("Regola{1-S}NonPresente", [regola.Azione]));
    }

    return errori;
}

export function GetValueFromString(o: any, s: any, v: any): any {
    try {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (o != "" && k in o) {
                o = o[k];
            } else {
                return v;
            }
        }

        return o;
    }
    catch (e) {
        console.error("GetValueFromString", e, o, s, v);
    }
}

export function Maggiore(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (ValoreCampo(state, nomeCampo) <= ValoreSoggetto(state, regola)) {
        errori = AddErrore(errori, Trad.TradParam("{1-S}inferioreAl{2-S}", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
    }
    return errori;
}

export function MaggioreUguale(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (ValoreCampo(state, nomeCampo) < ValoreSoggetto(state, regola.Soggetto)) {
        errori = AddErrore(errori, Trad.TradParam("{1-S}inferioreAl{2-S}", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
    }
    return errori;
}

export function Minore(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (ValoreCampo(state, nomeCampo) >= ValoreSoggetto(state, regola)) {
        errori = AddErrore(errori, Trad.TradParam("{1-S}superioreDel{2-S}", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
    }
    return errori;
}

export function MinoreUguale(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (ValoreCampo(state, nomeCampo) > ValoreSoggetto(state, regola)) {
        errori = AddErrore(errori, Trad.TradParam("{1-S}superioreDel{2-S}", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
    }
    return errori;
}

export function Uguale(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (ValoreCampo(state, nomeCampo) != ValoreSoggetto(state, regola)) {
        errori = AddErrore(errori, Trad.TradParam("{1-S}diversoDa{2-S}", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
    }
    return errori;
}

export function Alternativo(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (regola.SeValorizzato == undefined || (regola.SeValorizzato != undefined && ValoreSeValorizzato(state, regola))) {
        if (ValoreVuoto(ValoreCampo(state, nomeCampo)) && ValoreVuoto(ValoreSoggetto(state, regola))) {
            errori = AddErrore(errori, Trad.TradParam("Ne{1-S}ne{2-S}sonoStatiCompilati", [Trad.Trad(nomeCampo), Trad.Trad(etichetta)]));
        }
    }
    return errori;
}

export function Richiesto(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    if (regola.SeValorizzato == undefined || (regola.SeValorizzato != undefined && !ValoreVuoto(ValoreSeValorizzato(state, regola)))) {
        if (regola.Soggetto == undefined && ValoreVuoto(ValoreCampo(state, nomeCampo))) {
            errori = AddErrore(errori, Trad.TradParam("{1-S}èObbligatorio", [Trad.Trad(NomeCampoSingolo(nomeCampo, etichetta))]));
        } else if (regola.Soggetto != undefined && (ValoreVuoto(ValoreCampo(state, nomeCampo)) || ValoreVuoto(ValoreSoggetto(state, regola)))) {
            errori = AddErrore(errori, Trad.TradParam("{1-S}èObbligatorio", [Trad.Trad(NomeCampoSingolo(nomeCampo, etichetta))]));
        }
    }
    return errori;
}

export function Somma(state: any, nomeCampo: any, regola: any, errori: string[], etichetta: string): string[] {
    let soggetti: string[] = regola.Soggetti
    let somma: number = 0;

    if (regola.SeValorizzato == undefined || (regola.SeValorizzato != undefined && ValoreSeValorizzato(state, regola))) {
        for (let i: number = 0; i < soggetti.length; i++) {
            somma += Number(GetValueFromString(state, soggetti[i], undefined));
        }


        if (somma != Number(regola.Totale)) {
            errori = AddErrore(errori, Trad.TradParam("{1-S}NonHaRaggiuntoValoreNecessario{2-D}SeiSoloA{3-D}", [Trad.Trad(nomeCampo), regola.Totale, somma]));
        }
    }

    return errori;
}

export function GetValore(state: any, campo: any, valoreDiDefault: any, incremento: any | undefined): any {
    let valore: any = 0;
    valore = GetValueFromString(state, campo, valoreDiDefault);
    if (incremento != undefined)
        valore = valore + incremento;
    return valore;
}

export function ValoreVuoto(valore: any): boolean {
    if (valore == undefined || valore == "" || valore == 0 || valore == 0.00 || valore == "0.00" || valore == "0,00" || false)
        return true;
    else
        return false;
}

export function ValoreCampo(state: any, nomeCampo: any): any {
    if (nomeCampo != undefined)
        return GetValueFromString(state, nomeCampo, undefined);
    else
        return undefined;
}

export function ValoreSoggetto(state: any, regola: any): any {
    if (regola.Soggetto != undefined)
        return GetValore(state, regola.Soggetto, regola.Valore, regola.Incremento);
    else
        return undefined;
}

export function ValoreSeValorizzato(state: any, regola: any): any {
    //return GetValore(state, regola.SeValorizzato, regola.Valore, undefined);

    if (regola.SeValorizzato != undefined) {
        return GetValueFromString(state, regola.SeValorizzato, false);
    } else {
        return false;
    }
}

export function NomeCampoSingolo(nomeCampo: string, soggetto: string) {
    if (soggetto == undefined)
        return nomeCampo;
    else
        return soggetto;
}

export function AddErrore(errori: string[], errore: string): string[] {
    errori.push(errore);
    errori.push("<br />");
    return errori;
}


// WEBPACK FOOTER //
// ./src/components/Regole.tsx